import { ref, computed } from "vue";

const pendingCallSid = ref<string | null>(null);
const isDispositionPending = ref(false);

const isPostCallLocked = computed(() => !!pendingCallSid.value);

function startPostCallLock(callSid: string) {
  if (pendingCallSid.value === callSid) return;
  pendingCallSid.value = callSid;
  isDispositionPending.value = false;
}

function onCallSummaryReady() {
  if (!pendingCallSid.value || isDispositionPending.value) return;
  isDispositionPending.value = true;
}

function onDispositionSaved() {
  pendingCallSid.value = null;
  isDispositionPending.value = false;
}

function clearPostCallLock() {
  pendingCallSid.value = null;
  isDispositionPending.value = false;
}

export function usePostCallLock() {
  return {
    pendingCallSid,
    isDispositionPending,
    isPostCallLocked,
    startPostCallLock,
    onCallSummaryReady,
    onDispositionSaved,
    clearPostCallLock,
  };
}
